import { Box, Checkbox, Table } from "@mantine/core";

import { IconFiles } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

import { FILES_TABLE_COLUMNS } from "../constants/tables";
import { FilesTableProps } from "../interfaces/encounter-table";

import { EmptyStateTable } from "./EmptyStateTable";

export function FilesTable({ items, onItemChange }: FilesTableProps) {
  if (items.length === 0) {
    return (
      <EmptyStateTable
        columns={FILES_TABLE_COLUMNS}
        message="There are currently no files for this client."
        icon={<IconFiles size={18} color="var(--mantine-color-gray-6)" />}
      />
    );
  }

  return (
    <Box
      style={{
        overflow: "hidden",
        borderRadius: "var(--mantine-radius-md)",
        border: "1px solid var(--mantine-color-cream-4)",
      }}
    >
      <Table withRowBorders verticalSpacing="md" borderColor="cream.4" horizontalSpacing="md">
        <Table.Thead bg="cream.3">
          <Table.Tr>
            {FILES_TABLE_COLUMNS.map((column) => (
              <Table.Th key={column}>
                <TextWrapper c="dark.9" variant="bold">
                  {column}
                </TextWrapper>
              </Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {items.map(({ key, checked, fileName, fileType, dateAdded }, index) => (
            <Table.Tr key={key}>
              <Table.Td>
                <Checkbox
                  checked={checked}
                  label={dateAdded ?? "-"}
                  onChange={(event) => onItemChange(index, event.currentTarget.checked)}
                />
              </Table.Td>
              <Table.Td>
                <TextWrapper>{fileName ?? "-"}</TextWrapper>
              </Table.Td>
              <Table.Td>
                <TextWrapper>{fileType ?? "-"}</TextWrapper>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Box>
  );
}
